<template>
  <a-space direction="vertical" style="width: 100%; ">
    <div
      style="position: relative;"
      v-for="(condition, index) in initState.ruleConditions"
      :key="index"
    >
      <DeleteOutlined
        v-if="initState.editable"
        @click="initState.removeCondition(index)"
        style="position: absolute; cursor: pointer; right: -32px; bottom: 10px;"
      />
      <span
        :style="{
          cursor: 'pointer',
          color: '#1890ff',
          display: 'inline-block',
          marginBottom: '8px'
        }"
        v-if="index !== 0"
        @click="initState.changeConjunction(index)"
      >
        {{ condition.conjunction === 0 ? '且' : '或' }}
      </span>
      <a-row gutter="8">
        <a-col span="8">
          <a-select
            placeholder="请选择条件"
            :disabled="!initState.editable"
            v-model:value="condition.conditionKey"
            @change="onConditionKeyChange(condition)"
          >
            <a-select-option
              v-for="item in initState.conditionList"
              :key="item.conditionKey"
              :value="item.conditionKey"
            >
              {{ item.conditionKeyName }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col span="8">
          <a-select
            placeholder="请选择"
            v-model:value="condition.conditionOperationSymbols"
            :disabled="!initState.editable"
            @change="onConditionSymbolsChange(condition)"
          >
            <template v-if="condition.conditionKey">
              <a-select-option
                v-for="operation in getOperations(condition)"
                :key="operation.symbols"
                :value="operation.symbols"
              >
                {{ operation.name }}
              </a-select-option>
            </template>
          </a-select>
        </a-col>
        <a-col span="8">
          <a-input-number
            v-if="getValueType(condition) === 0"
            :min="1"
            :disabled="
              !condition.conditionOperationSymbols || !initState.editable
            "
            style="width: 100%;"
            v-model:value="condition.conditionValue"
            :precision="0"
            :addon-after="condition.conditionKey === 3003 ? null : 's'"
          ></a-input-number>
          <a-select
            placeholder="请选择值"
            style="width: 100%;"
            v-else
            :disabled="
              !condition.conditionOperationSymbols || !initState.editable
            "
            v-model:value="condition.conditionValue"
          >
            <a-select-option
              v-for="i in getValueOptions(condition)"
              :key="i.value"
              :value="i.value"
              >{{ i.name }}</a-select-option
            >
          </a-select>
        </a-col>
      </a-row>
    </div>
  </a-space>
  <div v-if="initState.ruleConditions.length < 3 && initState.editable">
    <span
      @click="initState.addCondition"
      style="cursor: pointer; color: #1890ff; margin-top: 8px; display: inline-block;"
    >
      +条件
    </span>
  </div>
</template>

<script setup>
import { DeleteOutlined } from '@ant-design/icons-vue'
import { inject } from 'vue'

const initState = inject('initState')

const getOperations = condition => {
  const key = condition.conditionKey

  const item = initState.conditionList.find(i => i.conditionKey === key)

  if (item) {
    return item.conditionOperation
  }

  return []
}

const getValueType = condition => {
  const key = condition.conditionKey

  const item = initState.conditionList.find(i => i.conditionKey === key)

  return item ? item.conditionValueType : 0
}

const getValueOptions = condition => {
  const key = condition.conditionKey

  const item = initState.conditionList.find(i => i.conditionKey === key)

  return item ? item.conditionValue : []
}

const onConditionKeyChange = condition => {
  condition.conditionOperationSymbols = null
  condition.conditionValue = null
  condition.conditionValueType = getValueType(condition)
}

const onConditionSymbolsChange = condition => {
  condition.conditionValue = null
}
</script>
